/* eslint-disable no-undef */
// @ts-nocheck
let commonAnalyticsData;
let phoneNumber = '';
const createBody = (data?) => {
  return {
    Tag: 'GoKwik',
    Products: commonAnalyticsData?.products,
    Currency: commonAnalyticsData?.currency,
    'Promo Code': commonAnalyticsData?.coupon || '',
    'Cart Total Price': commonAnalyticsData?.cart_after_discount,
    ...data,
  };
};

const klaviyoIdentifyCall = (data, phone) => {
  const identifyCredentials = {
    $email: data.userAddress?.email,
    $first_name: data.userAddress?.firstname,
    $last_name: data.userAddress?.lastname,
    $phone_number: phone,
  };

  _learnq.push(['identify', identifyCredentials]);
};

export const callKlaviyo = (eventName, data) => {
  data.commonAnalyticsData && (commonAnalyticsData = data.commonAnalyticsData);
  if (eventName === 'Started_Checkout_GK') {
    klaviyoInitFunction();
  } else if (eventName == 'mobileAddedGK') {
    klaviyoMobileGK(data);
  } else if (eventName == 'pinCode') {
    klaviyoPinCode(data);
  } else if (eventName == 'paymentMethod') {
    klaviyoPaymentMethod(data);
  } else if (eventName == 'paymentCompleted') {
    klaviyoPaymentCompleted(data);
  } else if (eventName == 'userAddress') {
    klaviyoUserAddress(data);
  }
};
const klaviyoInitFunction = () => {
  _learnq.push(['track', 'Started_Checkout_GK', createBody()]);
};

const klaviyoMobileGK = (data) => {
  phoneNumber = data.evt.phoneNumber;
  let credentials = {
    eventName: 'Mobile_Added_GK',
    data: createBody({
      'Mobile Number': `+91${data.evt.phoneNumber}`,
      'Abandoned URL': data.abcURL,
      ABC_sms: data.abcURL + `&ch=klaviyo&src=sms`,
      ABC_mail: data.abcURL + `&ch=klaviyo&src=mail`,
      ABC_wa: data.abcURL + `&ch=klaviyo&src=wa`,
      ABC_limechat: data.abcURL + `&ch=klaviyo&src=limechat`,
      ABC_zoko: data.abcURL + `&ch=klaviyo&src=zoko`,
      ABC_gupshup: data.abcURL + `&ch=klaviyo&src=gupshup`,
    }),
  };
  _learnq.push(['track', credentials.eventName, credentials.data]);
};

const klaviyoPinCode = (data) => {
  let credentials = {
    eventName: 'PIN_Code_Added_GK',
    data: createBody({
      Pincode: data.evt.pincode,
      ZIP: data.evt.pincode,
    }),
  };
  _learnq.push(['track', credentials.eventName, credentials.data]);
};
const klaviyoPaymentMethod = (data) => {
  commonAnalyticsData = data.commonAnalyticsData;
  let credentials = {
    eventName: 'Payment_Method_Selected_GK',
    data: createBody({
      'Mobile Number': `+91${data.userAddress?.phone}`,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: data.userAddress?.pincode,
      Country: 'India',
      'Shipping Method': data.shippingMethod,
      'Payment method': data.evt.paymentMethod,
      'Abandoned URL': data.abcURL,
      ABC_sms: data.abcURL + `&ch=klaviyo&src=sms`,
      ABC_mail: data.abcURL + `&ch=klaviyo&src=mail`,
      ABC_wa: data.abcURL + `&ch=klaviyo&src=wa`,
      ABC_limechat: data.abcURL + `&ch=klaviyo&src=limechat`,
      ABC_zoko: data.abcURL + `&ch=klaviyo&src=zoko`,
      ABC_gupshup: data.abcURL + `&ch=klaviyo&src=gupshup`,
      Region: data.userAddress?.state,
      'Address Type': data.userAddress?.addresstype,
    }),
  };
  _learnq.push(['track', credentials.eventName, credentials.data]);
};
const klaviyoPaymentCompleted = (data) => {
  commonAnalyticsData = data.commonAnalyticsData;

  let credentials = {
    eventName: 'Payment_Complete_GK',
    data: createBody({
      'Payment Complete': '',
      Token: data.token,
      'Mobile Number': `+91${data.userAddress?.phone}`,
      'First Name': data.userAddress?.firstname,
      'Last Name': data.userAddress?.lastname,
      Email: data.userAddress?.email,
      'Full Address': data.userAddress?.address,
      'Address Type': data.userAddress?.addresstype,
      City: data.userAddress?.city,
      State: data.userAddress?.state,
      Pincode: data.userAddress?.pincode,
      Country: 'India',
      'Shipping Method': data.shippingMethod,
      'Payment Method': data.paymentMethod,
      Region: data.userAddress?.state,
    }),
  };
  _learnq.push(['track', credentials.eventName, credentials.data]);
};

const klaviyoUserAddress = (data) => {
  commonAnalyticsData = data.commonAnalyticsData;
  let credentials = {
    eventName: data.eventName,
    type: data.type,
    data: createBody({
      'Mobile Number': `+91${data.evt.userAddress?.phone}`,
      'First Name': data.evt.userAddress?.firstname,
      'Last Name': data.evt.userAddress?.lastname,
      Email: data.evt.userAddress?.email,
      'Full Address': data.evt.userAddress?.address,
      City: data.evt.userAddress?.city,
      State: data.evt.userAddress?.state,
      Pincode: data.evt.userAddress?.pincode,
      'Address Type': data.evt.userAddress?.addresstype,
      'Shipping Method': data.evt.shippingMethod,
      'Abandoned URL': data.evt.abcURL,
      ABC_sms: data.evt.abcURL + `&ch=klaviyo&src=sms`,
      ABC_mail: data.evt.abcURL + `&ch=klaviyo&src=mail`,
      ABC_wa: data.evt.abcURL + `&ch=klaviyo&src=wa`,
      ABC_limechat: data.evt.abcURL + `&ch=klaviyo&src=limechat`,
      ABC_zoko: data.evt.abcURL + `&ch=klaviyo&src=zoko`,
      ABC_gupshup: data.evt.abcURL + `&ch=klaviyo&src=gupshup`,
    }),
  };

  klaviyoIdentifyCall(data.evt, `+91${data.evt.userAddress?.phone}`);

  setTimeout(() => {
    _learnq.push(['track', credentials.eventName, createBody({ ...credentials.data })]);
  }, 1500);
};
